module.exports = __webpack_public_path__ + "img/periodo.5cc150c5.png";